import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>வைதீகத்துக்குத் தயாராகுதல்</h1>
  <mat-accordion>
    <mat-expansion-panel>
    <mat-expansion-panel-header>01. காலைக் கடமை
      </mat-expansion-panel-header>
      <div class="div3">
        
      
            <img src="assets/img/gajendra_varadhar-b.jpg" style="width: 100%;" />
       
            <p style="text-align: center">
             <strong><span style="font-size: 16pt; color: #0000ff">
                   அநுஷ்டானம்</span></strong></p>
            <p style="text-align: center">
             <span style="color: #ff0033"><strong>காலை தர்மம்</strong></span></p>
        
        
            <ul>
             <li>ஸூர்ய உதயத்திற்கு முன்பே துயிலெழவேண்டும்.</li>
             <li>ஹரி: என்ற நாமத்தை ஏழுதரம் கூறவேண்டும்.</li>
             <li></li>
             <li>கஜேந்த்ர மோக்ஷ படத்தை பார்த்தல் அல்லது அந்தக் கதையை நினைத்து கஜேந்த்ர வரதனை த்யானித்தல்.</li>
             <li>கீழ் ச்லோகத்தைச் சொல்லவேண்டும்.</li>
           
           <li>
             &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; ப்ராத: ஸ்மராமி பவபீதி மஹார்த்தி சாந்த்யை
             <br />
             &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; நாராயணம் கருட வாஹந மஞ்ஜநாபம்!<br />
             &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; க்ராஹாபிபூத மதவாரண முக்தி ஹேதும்<br />
             &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; சக்ராயுதம் தருண வாரிஜபத்ரநேத்ரம் !!</li>
           
          <li>  &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; 'ஓம் நம: க்ஷிதிதராய' என்று சொல்லி காலைத் தரையில்
            வைத்து படுக்கையை விட்டு எழுந்திருக்கவேண்டும். பூமாதேவியை காலினால் தொடுவதற்காக பொருத்தருள
            ப்ரார்த்திக்கவேண்டும்.</li>
          <li>
            &nbsp; &nbsp; &nbsp; &nbsp; பூணலைக் காதில் சுற்றிக்கொண்டு, மூன்றுதடவை கைகளைத் தட்டி
            ஒலி எழுப்பி அவ்விடத்திலுள்ள பூதங்களை அப்புறம் செல்லுமாறு ப்ரார்த்தித்துக் கொண்டு
            மெளனமாக மலஜலம் விஸர்ஜனம் செய்ய வேண்டும். புண்ய தீர்த்தமல்லாத தீர்த்தத்தைக் கொண்டு
            ப்ரக்ஷாளனம் (அலும்புதல்) பண்ணிக்கொள்ளவேண்டும்.</li>
</ul>

          
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>02. ஸ்நானம்
        </mat-expansion-panel-header>
        <div class="div3">
          <div class="hint">
            <span class="title3">ஸங்கல்பம்:-</span> பாதங்களை அலம்பிக்கொண்டு
            இருமுறை ஆசமனம் செய்து, பவித்ரம் அணிந்து, ப்ராணாயாமம் செய்து,
            கைகூப்பிக் கொண்டு சொல்லவும்.<br>
            ஏழு வகை ஸ்நானங்கள் உள்ளன - விபரம் இறுதியில் வழங்கப்பட்டுள்ளது.
          </div>
          <div class="sans">
           "ஓம் அஸ்மத் குருப்யோ நம:" ... + "ஸ்ரீபகவதாஜ்ஞயா ...ம்"<br>
           நித்ய நைமித்திக கர்மண்யதா ஸித்தியர்த்தம் ப்ராத: ஸ்நானம் அஹம் கரிஷ்யே!<br>
           (வடகலையார் - பகவாநேவ ... ஸ்வசேஷபூதமிதம் ப்ராதஸ் ஸ்நானாக்யம்
           ஸ்வஸ்மை ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரயதி. )<br>
           <span class="title3">ஆவாஹனம்:</span> 

           समस्त जगदाधार शङ्खचक्र गदाधर।
          देहि देव ममानुज्ञां युष्मत्तीर्थ निषेवणे।।
          <br>
          ஸமஸ்த ஜகதாதார சங்கசக்ர கதாதர<br>
          தேஹி தேவ மமாநுஜ்ஞாம் யுஷ்மத்தீர்த்த நிஷேவணே.<br>
          ஸ்ரீஹரிர்ஹரிர்ஹரி:<br>
          <span class="hint">என்று நீராடி, தீர்தத்தில் பகவானை தியானித்துக்கொண்டு,
            ஜலத்தில் சதுரமாக பீடம் எழுதி</span><br>
            யம் வாயவே நம: சோஷயாமி<br>
            ரம் அக்நயே நம: தாஹயாமி <br>
            வம் அம்ருதாய நம: ப்லாவயாமி <br> 
            <span class="hint">என முறையே வலலது - இடது - வலது 
              கைகளில் எழுதி நீரில் காண்பிக்கவேண்டும். <br>
              சதுரத்திற்கு வெளியில் இருந்து இரு கைகளாலும் தீர்த்தம் எடுத்து, 
            </span><br>
            आवाहयामि त्वां देवि स्नानार्थमिह सुन्दरी।<br>
            एहि गंगे नमस्तुभ्यं सर्वतीर्थसमन्विते।।<br>
            ஆவாஹயாமி த்வாம் தேவி ஸ்நாநார்த்தமிஹ சுந்தரீ.<br>
            ஏஹி கங்கே நமஸ்துப்யம் ஸர்வதீர்த்த ஸமந்விதே.<br>
            <span class="hint">என்று மந்திரித்து, சதுரத்திற்குள் சேர்த்து
              கங்கையை த்யானித்து</span><br>
              विष्णुपादाब्ज संभूते गंगे त्रिपथगामिनि ।<br>
              धर्मद्रवेति विख्याते पापं मे हर जाह्णवि।।<br>
              விஷ்ணு பாதாப்ஜ ஸம்பூதே கங்கே த்ரிபதகாமிநி.<br>
              தர்மத்ரவேதி விக்யாதே பாபம் மே ஹர ஜாஹ்ணவி.<br>            
          </div>
          <div class="div3">
            <div class="head3">7 வகை ஸ்நானம்</div>
            ஸ்நானங்கள் ஏழு வகை என சாஸ்திரம் பகர்கிறது. 
            <span class="title3">1.வாருண ஸ்நானம்</span>ஜலத்தில் அமிழ்ந்து தலை முழுகுவது
            <span class="title3">2. பார்த்திவ ஸ்நானம்</span>
            “ம்ருத்திகே ஹநமே பாபம்” என்று தொடங்கும் மந்திரங்களால் தேஹம் முழுவதும் சுத்தமான மண்ணைப் பூசிக்கொள்வது.
            <span class="title3">3. ஆக்நேய ஸ்நானம்</span>அக்நிஹோத்ர பஸ்மத்தை “ஈசாநம்” முதலிய மந்திரங்களால் தேஹத்தில் பூசுவது.
            <span class="title3">4. வாயவ்ய ஸ்நானம்</span>பசுக்களின் குளம்புத் தூள்களை கோஸாவித்ரியால் ஜபித்து உடம்பில் பூசிக்கொள்வது.
            <span class="title3">5. திவ்ய ஸ்நானம்</span>உத்தராயண மத்யத்தில் வெயிலுடன் சேர்ந்து மழைபெய்யும்போது அதில் நனைவதாகும். 
            <span class="title3">6. மந்த்ர ஸ்நானம்</span>“ஆபோஹிஷ்டா ” என்னும் மந்த்ரத்தால் முறையே கால், தலை, மார்பு, தலை, மார்பு, கால், மார்பு, கால், தலை இந்த இடங்களில் தீர்த்தத்தால் ப்ரோக்ஷித்துக்கொள்ளவேண்டும். 
            <span class="title3">7. மாநஸ ஸ்நானம்</span> சங்கசக்ர தரனாய் சூர்ய மண்டல மத்தியில் ஸ்வர்ண வர்ண சாயை உடையவனாய் பகவான் எழுந்தருளி யிருப்பதாகவும், 
            அவர் திருடிப் பெருவிரலில் இருந்து கங்கை ப்ரவாஹித்து ப்ரஹ்ம ரந்தரத்தின் வழியாய்த் 
            தன் தேஹத்தில் விழுவதாகவும், அதனால் தன் தேஹத்தில் உள்ளும் புறமும் உள்ள எல்லா
            மலமும் கழிந்துவிட்டதாகவும் த்யானம் செய்வதேயாகும். 
            <span class="title3">மற்ற ஸ்நானங்கள்</span> மேற்சொன்னவை தவிர 
            இரண்டு கால், இரு கைகள், முகம் இவைகளைக் கழுவுவது பஞ்சாங்க ஸ்நானம். <br>
            ஈரத்துணியால் உம்பு முழுவதையும் துடைத்துக்கொள்வது காபில ஸ்நானம். <br>
            புண்ட்ரம் தரிப்பதும் ஒரு வகைச் ஸ்நானமாகச் சொல்லப்படுகிறது. <br> 
            ஈர வஸ்திரத்துடன் ஒரு காரியமும் செய்யலாகாது. வேறு உலர்ந்த வஸ்த்ரம் இல்லாவிட்டால்
            ஈர வஸ்த்திரத்தை ஏழு முறை காற்றில் உதறி விட்டால் அது உலர்ந்த வஸ்திரமாக 
            சாஸ்த்திரம் ஏற்கிறது. 
            
          </div>
        </div>
        
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>03. வஸ்த்ரம் தரித்தல்
          </mat-expansion-panel-header>
          <div class="div3">
            <div class="mydiv">
              இங்கே கச்சம் அணிவது எப்படி என விளக்கி ஒரு
              gif (இன்டர்நெட் தேவையில்லை) ஒன்றும், வீடியோ
              ஒன்றும் வழங்கப்பட்டுள்ளது. <hr>
              ப்ரஹ்மசாரியானால் ஒரு வஸ்த்ரமும்,
              க்ருஹஸ்தர்களானால் இரு வஸ்த்ரமும் கட்டாயம்
              எப்போதும் இருக்கவேண்டும். <hr>
              மூன்றாவது வஸ்த்ரம் (த்ருதீய வஸ்த்ரம்) ஒன்று
              இருந்தால், மேனியின் மேல் பகுதியைப் போற்றிக்கொள்ள,
              காயத்ரி ஜபம் போன்ற காலங்களில் உபயோகமாக இருக்கும்.
              கடி ஸூத்ரம் எனும் அரைஞாண் கயிறு அவசியம். <br>
              ஈர வஸ்திரத்துடன் ஒரு காரியமும் செய்யலாகாது. வேறு உலர்ந்த வஸ்த்ரம் இல்லாவிட்டால்
            ஈர வஸ்த்திரத்தை ஏழு முறை காற்றில் உதறி விட்டால் அது உலர்ந்த வஸ்திரமாக 
            சாஸ்த்திரம் ஏற்கிறது. 
            </div>
            <ion-item>
              <div class="video-container">
        
                  <iframe src="https://www.youtube.com/embed/rOL27DwPHSs?rel=0" frameborder="0" width="300" height="169"></iframe>
              </div>
              </ion-item>
            <div class="tab">
              <input id="tab01" type="radio" name="tabs2">
              <label for="tab01">கச்சம் அணிவது எப்படி?</label>
              <div class="tab-content">
        
        <img src="assets/img/vasthra-dharanam.gif" style="width:100%;">
        <hr>
        <ion-item>
            <div class="video-container">
                <iframe src="https://www.youtube.com/embed/LkhCY4VO6j0?rel=0" frameborder="0" width="300" height="169"></iframe>
                </div>
            </ion-item>
        
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>04. திருமண் காப்பு
            </mat-expansion-panel-header>
            <div class="div3">
              <div class="hint">
                புண்ட்ர தாரண விஷயத்தில் தத்தம் பொரியோர் அநுஷ்டித்த முறையையே 
                பின்பற்றி (திருமண், கோபி, சந்தனம், பஸ்பம் இவைகளை இட்டுக்கொள்ள வேண்டும்.)
                சுத்தமான இடத்தில், சிறிது ஜலம் ப்ரோக்ஷித்து, கிழக்குப் பார்க்க சம்மணமிட்டு அமர்ந்துகொண்டு, கீழ்க்கண்ட வரிசையில் திருமண் மற்றும்
                ஸ்ரீசூர்ணத்தை குழைத்து அந்தந்த மந்திரத்துடன் இட்டுக்கொள்ளவும்.
      
              </div>
              <div class="mydiv">
                  <h2>திருமண் தரிக்கும் க்ரமம்</h2>
              </div>
              <img src="assets/img/thiruman-kaappu.jpg">
              <br>
              <div class="prayogam">
      
                  <ion-grid>
                      <ion-row>
                        <ion-col col-4>
                            1. நெற்றி
                        </ion-col>
                        <ion-col>
                            கேஸவாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            2. நடு வயிறு
                        </ion-col>
                        <ion-col>
                            நாராயணாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            3. மார்பு
                        </ion-col>
                        <ion-col>
                            மாதவாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            4. நடு கழுத்து
                        </ion-col>
                        <ion-col>
                            கோவிந்தாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            5. வலது வயிறு
                        </ion-col>
                        <ion-col>
                            விஷ்ணவே நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            6. வலது புஜம்
                        </ion-col>
                        <ion-col>
                            மதுசூதனாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            7. வலக் கழுத்து
                        </ion-col>
                        <ion-col>
                            திரிவிக்ரமாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            8. இடது வயிறு
                        </ion-col>
                        <ion-col>
                            வாமனாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            9. இடது புஜம்
                        </ion-col>
                        <ion-col>
                            ஸ்ரீதராய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            10. இடக் கழுத்து
                        </ion-col>
                        <ion-col>
                            ருஷிகேஸாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            11. அடி முதுகு
                        </ion-col>
                        <ion-col>
                            பத்மநாபாய நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            12. பின் கழுத்து
                        </ion-col>
                        <ion-col>
                            தாமோதராய நம:
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                இடது கையில் மீதம் உள்ள திருமண்ணை,
                வாசுதேவாய நம: என்று உச்சந்தலையில்
                தடவிக்கொள்ளவேண்டும்.
              </div>
              <hr>
              <div class="mydiv">
              <h2>ஸ்ரீசூர்ணம் தரிக்கும் க்ரமம்</h2></div>
              <img src="assets/img/srichurnam-final.jpg">
      
              <div class="prayogam">
                  <ion-grid>
                      <ion-row>
                        <ion-col col-4>
                            1. நெற்றி
                        </ion-col>
                        <ion-col>
                            ஸ்ரீயை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            2. நடு வயிறு
                        </ion-col>
                        <ion-col>
                            அம்ருதோத் பவாயை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            3. மார்பு
                        </ion-col>
                        <ion-col>
                            கமலாயை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            4. நடு கழுத்து
                        </ion-col>
                        <ion-col>
                            சந்த்ரசோதர்யை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            5. வலது வயிறு
                        </ion-col>
                        <ion-col>
                            விஷ்ணுபத்ந்யை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            6. வலது புஜம்
                        </ion-col>
                        <ion-col>
                            வைஷ்ணவ்யை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            7. வலக் கழுத்து
                        </ion-col>
                        <ion-col>
                            வராரோஹாயை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            8. இடது வயிறு
                        </ion-col>
                        <ion-col>
                            ஹரிவல்லபாயை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            9. இடது புஜம்
                        </ion-col>
                        <ion-col>
                            சார்ங்கிண்யை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            10. இடக் கழுத்து
                        </ion-col>
                        <ion-col>
                            தேவதேவிகாயை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            11. அடி முதுகு
                        </ion-col>
                        <ion-col>
                            மஹாலக்ஷ்ம்யை நம:
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col col-4>
                            12. பின் கழுத்து
                        </ion-col>
                        <ion-col>
                            சுரசுந்தர்யை நம:
                        </ion-col>
                      </ion-row>
                    </ion-grid>
      
                 இடது கையில் மீதம் உள்ள ஸ்ரீசூர்ணத்தை
                 ஸர்வாபீஷ்ட பலப்ரதாயை நம: என்று
                 உச்சந்தலையில் தடவிக்கொள்ளவேண்டும்.</div>
      
                        </div>
          </mat-expansion-panel>
         
  </mat-accordion>`;

const SelfPreparePage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="தான் தயாராதல் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default SelfPreparePage;
